import React, { memo, useCallback } from 'react';
import { UseMutationResult } from '@tanstack/react-query';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import {
    TreeDataForMappingGrid,
    OrgChartHrMapping,
    MappingOptionType,
} from 'routes/HumanResourcesModule/Settings/OrgChartHrMappings/helpers/type';
import MappingChoices from 'routes/HumanResourcesModule/Settings/OrgChartHrMappings/components/MappingChoices';

type CustomParams = CellRendererParams<
    TreeDataForMappingGrid,
    OrgChartHrMapping | null
> & {
    updateMappingMutation: UseMutationResult;
};

function MappingChoicesCellRenderer({
    value,
    data,
    updateMappingMutation,
}: CustomParams) {
    const handleChange = useCallback(
        (
            _event: React.SyntheticEvent,
            newValue: OrgChartHrMapping | MappingOptionType | null,
        ) => {
            if (newValue === null) {
                updateMappingMutation.mutate({
                    title: null,
                    // TODO: try to remove this non-null assertion
                    orgChartHrSoftwareIds: [data!.value],
                });
            } else {
                // Destructure the `inputValue` and `title` properties from `newValue`
                const inputValue =
                    'inputValue' in newValue ? newValue.inputValue : undefined;
                const { title } = newValue;

                // Set `finalValue` to the value of `inputValue` if it exists, otherwise set it to the value of `title`.
                // An inoutValue is set only in the case when a user created a new value that didn't exist previously
                const finalInput = inputValue ?? title;

                updateMappingMutation.mutate({
                    title: finalInput,
                    // TODO: try to remove this non-null assertion
                    orgChartHrSoftwareIds: [data!.value],
                });
            }
        },
        // TODO: try to remove this non-null assertion
        [data!.value, updateMappingMutation],
    );

    return <MappingChoices value={value} handleChange={handleChange} />;
}

export default memo(MappingChoicesCellRenderer);
